import {
  Container,
  styled,
} from "@mui/material";

import SupportCard from "components/supportCards/SupportCard";

import Book from "../../assets/icons/Book.svg";
import Chat from "../../assets/icons/Chat.svg";
import Note from "../../assets/icons/Note.svg";
import WarningCircle from "../../assets/icons/WarningCircle.svg";

const SupportPage = () => {

  return (
    <StyledContainer className="SupportPage">
      <div className='SupportPage-cards'>
        <SupportCard
          key={'documentation'}
          title={'Documentation'}
          svgIcon={Book}
          redirect={'/assets/SE-2050-Database-User-Guide-v1.0.pdf'}
          isExternal
        />
        <SupportCard
          key={'report'}
          title={'Report Bugs'}
          svgIcon={WarningCircle}
          redirect={process.env.REACT_APP_TYPEFORM_BUGS_URL ?? '/support'}
          isExternal
        />
        <SupportCard
          key={'request'}
          title={'Request New Feature'}
          svgIcon={Note}
          redirect={process.env.REACT_APP_TYPEFORM_FEATURES_URL ?? '/support'}
          isExternal
        />
        <SupportCard
          key={'contact'}
          title={'Contact Support'}
          svgIcon={Chat}
          redirect={'/contact-us'}
        />
      </div>
    </StyledContainer>
  );
};

export default SupportPage;

const StyledContainer = styled(Container)({
  '& .SupportPage-cards': {
    display: 'grid',
    gridGap: 16,
    gridTemplateColumns: 'repeat(auto-fit, 250px)'
  }
});
